var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_4820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9742 18.7672L24.9294 16.7224V9.70826L26.2644 9.22697C26.5709 9.11643 26.7752 8.8258 26.7755 8.49996C26.7757 8.17422 26.5718 7.88317 26.2654 7.77227L14.0514 3.34894C13.8814 3.28733 13.6949 3.28733 13.5248 3.34894L1.31084 7.77227C1.00568 7.88281 0.802023 8.17205 0.800786 8.4966C0.799652 8.82116 1.00119 9.11189 1.30548 9.22465L5.81311 10.8944V15.9912C5.81311 16.1494 5.86157 16.3038 5.95206 16.4335C6.00181 16.5049 6.4731 17.1485 7.67975 17.7558C9.20415 18.5232 11.2036 18.9123 13.6223 18.9123C16.0393 18.9123 18.0489 18.524 19.595 17.7582C20.8136 17.1546 21.3005 16.5177 21.3521 16.4471C21.4486 16.3147 21.5006 16.1552 21.5006 15.9913V10.9444L23.3827 10.2658V16.7224L21.3379 18.7672C21.1928 18.9123 21.1113 19.109 21.1113 19.3141C21.1113 19.5192 21.1928 19.7159 21.3379 19.8609L23.3827 21.9057V23.6214C23.3827 24.0485 23.729 24.3947 24.1561 24.3947C24.5832 24.3947 24.9295 24.0485 24.9295 23.6214V21.9057L26.9743 19.8609C27.2763 19.559 27.2763 19.0692 26.9742 18.7672ZM13.7881 4.89861L23.7264 8.49779L13.626 12.1393L3.82263 8.50764L13.7881 4.89861ZM19.9539 15.683C17.31 18.062 9.4538 17.7892 7.35984 15.6907V11.4675L13.3537 13.6878C13.4488 13.7029 13.5386 13.7849 13.8846 13.6902L19.9539 11.5021L19.9539 15.683ZM24.1561 20.4917L22.9783 19.3141L24.1561 18.1363L25.3337 19.3141L24.1561 20.4917Z",
    fill: "#BEC0C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_4820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    fill: "white",
    transform: "translate(0.800781 0.650391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.def545cf9bde2cd3d40d34ac567439c5.svg";
export { ForwardRef as ReactComponent };